import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AnalystClarification, AnalystNarrowingOptions, AnalystOutputBlock, AnalystOutputType } from 'src/app/models/analyst-output.model';
import { CitationNumbering, EMPTY_CITATION_NUMBERING } from 'src/app/shared/utils/citation-resolver.util';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';

@Component({
  standalone: false,
  selector: 'app-analyst-output',
  templateUrl: './analyst-output.component.html',
  styleUrls: ['./analyst-output.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalystOutputComponent implements OnChanges {
  @Input() outputs: AnalystOutputBlock[] = [];
  @Input() citationNumbering: CitationNumbering = EMPTY_CITATION_NUMBERING;
  @Input() disabled = false;
  @Input() clarificationAnswered = false;
  @Input() clarificationAnswerText: string | null = null;
  @Output() optionSelected = new EventEmitter<string>();

  readonly AnalystOutputType = AnalystOutputType;
  readonly trackByIndex = trackByIndex;

  clarifications: AnalystClarification[] = [];
  narrowingOptions: AnalystNarrowingOptions | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['outputs']) {
      this.clarifications = this.outputs
        .filter((block) => block.type === AnalystOutputType.Clarification)
        .map((block) => block.clarification)
        .filter((clarification): clarification is AnalystClarification => !!clarification);

      // At most one is ever produced per turn (system-emitted, appended once by the orchestrator).
      this.narrowingOptions = this.outputs.find((block) => block.type === AnalystOutputType.NarrowingOptions)?.narrowingOptions ?? null;
    }
  }
}
